import { useAuth } from './auth-context';
import { canAccessMasterDashboard } from './roles';
import { useWorkspace } from './workspace-context';

/**
 * Le classement est-il activé pour le workspace affiché ?
 * Un joueur lit le drapeau de son propre workspace ; un admin DarwinX celui du workspace sélectionné.
 */
export function useLeaderboardEnabled(): boolean {
  const { user } = useAuth();
  const { workspaces, workspaceId } = useWorkspace();
  if (!user) return false;
  if (canAccessMasterDashboard(user)) {
    return workspaces.find((workspace) => workspace.id === workspaceId)?.leaderboardEnabled ?? false;
  }
  return user.leaderboard_enabled === true;
}

/** Le joueur doit choisir son pseudo avant d'entrer (workspace activé, pas encore de pseudo). */
export function needsPlayerProfile(
  user: { department?: string | null; pseudo?: string | null; leaderboard_enabled?: boolean } | null,
): boolean {
  return Boolean(user && user.department && user.leaderboard_enabled && !user.pseudo);
}
